import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';
import { KeysConfigDevice } from 'src/utils/keys';
import ComboboxImage from '../Input/ComboboxImage';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ConfigDeviceModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = React.useRef(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const keysConfigDevice = KeysConfigDevice;
    const [ipAddDevice, setIpAddDevice] = useState('');
    const [portnoDevice, setPortnoDevice] = useState('');
    const [serialNo, setSerialNo] = useState('');
    const [note, setNote] = useState('');
    const [pass, setPass] = useState('');
    const [account, setAccount] = useState('');
    const [cabinet, setcabinet] = useState(null);
    const [dataCabinet, setDataCabinet] = useState([]);
    const [getFlagsCainet, setGetFlagsCainet] = useState(false);
    const getCabinetFlags = useRef();

    const [isSubmit, setIsSubmit] = useState(false);
    // const optionGroup = [
    //     {
    //         label: t('staff'),
    //         value: '3',
    //     },
    //     {
    //         label: t('manager'),
    //         value: '2',
    //     },
    // ];
    // const [valueOption, setValueOption] = useState({
    //     label: t('staff'),
    //     value: '3',
    // });
    const handlChoose = () => {
        if (cabinet) {
            setVisible(false);
            sessionStorage.setItem('cabinet', JSON.stringify(cabinet));
        }
    };
    useEffect(() => {
        setTimeout(() => {
            getDataCabinet();
        }, 1000);
        if (isEdit) {
            setIpAddDevice(dataUpdate[keysConfigDevice.ipadd_device]);
            setPortnoDevice(dataUpdate[keysConfigDevice.portno_device]);
            setSerialNo(dataUpdate[keysConfigDevice.serial_no]);
            setNote(dataUpdate[keysConfigDevice.note]);
            setcabinet({
                id: dataUpdate[keysConfigDevice.cabinet_id],
                cabinet_nm: dataUpdate[keysConfigDevice.cabinet_nm],
            });
            setPass(dataUpdate[keysConfigDevice.password]);
            setAccount(dataUpdate[keysConfigDevice.account]);
        } else {
            setIpAddDevice('');
            setPortnoDevice('');
            setSerialNo('');
            setNote('');
            setAccount('');
            setAccount('');
            setcabinet({});
        }
        setIsSubmit(false);
    }, [dataUpdate]);

    const getDataCabinet = useCallback(() => {
        if (getCabinetFlags.current) return;
        getCabinetFlags.current = true;
        setGetFlagsCainet(true);
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);
    const getDataCabinetResult = (reqInfoMap, message) => {
        getCabinetFlags.current = false;
        setGetFlagsCainet(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const arrCabinet = message.proc_data.rows[0].o_1;
            setDataCabinet(message.proc_data.rows[0].o_1);
        }
    };
    const timeOutFunctCabinet = (reqInfo) => {
        getCabinetFlags.current = false;
        setGetFlagsCainet(false);
    };

    const handleEdit = () => {
        setIsSubmit(true);
        if (addFlag.current === true) return;
        if (!ipAddDevice || !portnoDevice || !serialNo || !cabinet || !pass || !account)
            return toast.error(t('error.param'));

        addFlag.current = true;
        setFlagAddStat(true);

        if (!isEdit) {
            let InVal = [cabinet.id, ipAddDevice, portnoDevice, serialNo, note, '0', pass, account];
            sendRequest(serviceList.insertConfigDevice, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            let InVal = [
                dataUpdate[keysConfigDevice.id],
                cabinet.id,
                ipAddDevice,
                portnoDevice,
                serialNo,
                note,
                pass,
                account,
            ];
            sendRequest(serviceList.updateConfigDevice, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();
            setVisible(!visible);
            setIsSubmit(false);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            // style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {!isEdit ? t('create_device') : t('update_device')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <ComboboxImage
                            // onEnterPress={handlChoose}
                            sizeCbb="small"
                            label={t('choose_cabinet')}
                            valueSelect={cabinet}
                            getValue={setcabinet}
                            displayImage="img_cabinet"
                            selectOption={dataCabinet?.filter((ele) => ele.block_status === '1')}
                            displayLabel="cabinet_nm"
                            valueEqual="id"
                            autoFocus
                            required
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('ip_add_device')}
                            valueChange={ipAddDevice}
                            getValue={setIpAddDevice}
                            required
                            error={!ipAddDevice && isSubmit}
                            helperText={!ipAddDevice && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('account')}
                            valueChange={account}
                            getValue={setAccount}
                            required
                            error={!account && isSubmit}
                            helperText={!account && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('password')}
                            valueChange={pass}
                            getValue={setPass}
                            type="password"
                            required
                            error={!pass && isSubmit}
                            helperText={!pass && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('serial_no')}
                            valueChange={serialNo}
                            getValue={setSerialNo}
                            required
                            error={!serialNo && isSubmit}
                            helperText={!serialNo && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('portno_device')}
                            valueChange={portnoDevice}
                            getValue={setPortnoDevice}
                            required
                            error={!portnoDevice && isSubmit}
                            helperText={!portnoDevice && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput type="text" label={t('note_')} valueChange={note} getValue={setNote} />
                    </Grid>
                    {/* <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('group_staff')}
                            valueSelect={valueOption}
                            required
                            getValue={setValueOption}
                            selectOption={optionGroup}
                        />
                    </Grid> */}
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ConfigDeviceModal;
